import { List, ListItem, styled, SxProps, Theme } from '@cmg/design-system';

export const dialogContentStyle: SxProps<Theme> = {
  paddingX: 3,
};
export const dialogRightPanelContentStyle: SxProps<Theme> = {
  padding: theme =>
    `${theme.spacing(2)} ${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(2)}`,
  backgroundColor: 'background.lightGrey',
};
export const StyledList = styled(List)(() => ({
  listStyleType: 'disc',
  paddingLeft: 20,
  paddingTop: 2,
  paddingBottom: 0,
}));
export const StyledListItem = styled(ListItem)(() => ({
  display: 'list-item',
  padding: 1,
  fontSize: 10,
}));
